import React, { Component } from 'react';
import { Provider } from 'react-redux';
import store from './store';
import RouterForm from './components/router_form';

/*window.onbeforeunload = (event) => {
    event.preventDefault();
    return event.returnValue = 'Are you sure you want to close?';
};*/

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <div className="App">
                    <RouterForm/>
                </div>
            </Provider>
        );
    }
}

export default App;
